import TransactionsGrid from "src/components/TransactionsGrid/TransactionsGrid";
import { useDataTableState } from "src/hooks/useDataTableState";
import { Configuration } from "src/models/ConfigurationModel";
import { useGetConfigurationsQuery } from "src/store/apis/Configuration";
import { columns, config } from "./columns";

export default function ConfigurationsPage() {
  const { filters, setFilters, dataColumns } = useDataTableState<Configuration>({
    columns,
    config,
  });

  const { data, isLoading, isFetching, refetch } = useGetConfigurationsQuery(
    {
      Category: filters?.category,
    },
    { refetchOnMountOrArgChange: true },
  );

  return (
    <TransactionsGrid
      onFilterChange={setFilters}
      rowKey="key"
      columns={dataColumns}
      dataSource={data?.result ?? []}
      isLoading={isLoading || isFetching}
      refetch={refetch}
      totalItems={data?.result?.length ?? 0}
    />
  );
}